import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';

// 30-minute rolling session window
const SESSION_TTL_MS = 30 * 60 * 1000;

function getOrCreateSession() {
    try {
        let id = localStorage.getItem('dt_session_id');
        const ts = parseInt(localStorage.getItem('dt_session_ts') || '0', 10);
        const now = Date.now();
        if (!id || now - ts > SESSION_TTL_MS) {
            id = (crypto?.randomUUID && crypto.randomUUID()) || Math.random().toString(36).slice(2) + Date.now();
            localStorage.setItem('dt_session_id', id);
        }
        localStorage.setItem('dt_session_ts', String(now));
        return id;
    } catch (_) {
        return null;
    }
}

function sameOriginReferrer(referrer) {
    if (!referrer) return '';
    return referrer.startsWith(window.location.origin) ? '' : referrer;
}

async function trackPageView(path) {
    try {
        await api.post('/track', {
            path,
            referrer: sameOriginReferrer(document.referrer || ''),
            session_id: getOrCreateSession(),
            title: document.title || '',
        });
    } catch (err) {
        if (process.env.NODE_ENV !== 'production') console.debug('[useAnalytics] track failed:', err);
    }
}

export default function useAnalytics() {
    const location = useLocation();
    const path = location.pathname + (location.search || '');
    useEffect(() => {
        // Never track admin pages
        if (path.startsWith('/admin')) return;
        trackPageView(path);
    }, [path]);
}
